export const MIN_VALUE_TO_REGISTER_IN_SECONDS = 30;
export const DEFAULT_START_TIME = 0;
export const ONE_MINUTE_IN_SECONDS = 60;
export const READ_ENTRIES_LENGTH = 10;
export const ONE_DAY_IN_HOURS = 24;
export const SEVEN_DAYS = 7;
